import { initializeApp } from 'firebase/app'
import { getFirestore, collection, query, onSnapshot, orderBy, getDocs, getDoc, doc, limit, startAfter, where } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDacU8HGVpQrKQJzgqFTeuwG6viniPFofY",
    authDomain: "tsgmedia-e0472.firebaseapp.com",
    databaseURL: "https://tsgmedia-e0472.firebaseio.com",
    projectId: "tsgmedia-e0472",
    storageBucket: "tsgmedia-e0472.appspot.com",
    messagingSenderId: "393265654100",
    appId: "1:393265654100:web:33522d7bce719d9eb200c1",
    measurementId: "G-N293YFPT0L"
};

initializeApp(firebaseConfig)

let db = getFirestore()

async function getData(dbcollection, pagination) {
    let data = []

    try {
        if (!dbcollection || typeof dbcollection != 'string') return 'Something went wrong, invalid or no param'

        let colRef = collection(db, dbcollection)
        let q = query(colRef, orderBy('date_created', 'desc'))
        
        if (pagination) {
            if (pagination.startAfter) {
                let startDoc = await getDoc(doc(db, dbcollection, pagination.startAfter))
                q = query(q, startAfter(startDoc))
            }
            if (pagination.limit) {
                q = query(q, limit(pagination.limit))
            }
        }
        
        let docs = await getDocs(q)

        docs.docs.forEach(doc => {
            data.push({ id: doc.data().docId, data: doc.data() })
        })

        /**
         * onSnapshot(q, (res) => {
            console.log(res.docs)
            res.docs.forEach(doc => {
                data.push({ id: doc.data().docId, data: doc.data() })
            })
        })
         */

        return data
    } catch (error) {
        return 'An error occured: ' + error
    }
}

async function getSingleData(collection, docId) {
    let document

    try {
        if (!collection || typeof collection != 'string') return 'Something went wrong, invalid or no param'
        if (!docId) return 'Something went wrong, invalid or no param'

        let docRef = doc(db, collection, docId)

        let req = await getDoc(docRef)
        
        document = [{ id: req.data().docId, data: req.data() }]

        return document

    } catch (error) {
        if (error.message.includes("Cannot read properties of undefined (reading 'docId')")) {
            return 'Something went wrong, invalid or no param'
        } else {
            return 'An error occured: ' + error.message
        }
    }
}

async function getRandomSermons(limitCount = 4) {
    let data = []

    try {
        let colRef = collection(db, 'series')
        let docs = await getDocs(colRef)

        if (docs.empty) {
            return data
        }

        const items = docs.docs.map((doc) => {
            const sermonData = doc.data()
            return {
                id: sermonData.docId ?? doc.id,
                data: sermonData
            }
        })

        // Shuffle the array in place and take the first `limitCount` items
        for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[items[i], items[j]] = [items[j], items[i]]
        }

        data = items.slice(0, Math.min(limitCount, items.length))
        return data
    } catch (error) {
        return 'An error occurred: ' + error
    }
}


async function getSermonYears() {
    let years = new Set()

    try {
        let colRef = collection(db, 'series')
        let q = query(colRef, orderBy('date_created', 'desc'))
        let docs = await getDocs(q)

        docs.docs.forEach(doc => {
            let date = new Date(doc.data().date_created)
            years.add(date.getFullYear())
        })
        return Array.from(years).sort((a, b) => b - a) // Sort descending
    } catch (error) {
        return 'An error occurred: ' + error
    }
}

async function getSermons({ year, query: searchQuery, pagination }) {
    let data = []

    try {
        let colRef = collection(db, 'series')
        let q = query(colRef)

        if (year && typeof year === 'number') {
            let startOfYear = new Date(year, 0, 1).getTime()
            let endOfYear = new Date(year + 1, 0, 1).getTime()

            q = query(
                q,
                where('date_created', '>=', startOfYear),
                where('date_created', '<', endOfYear)
            )
        }

        q = query(q, orderBy('date_created', 'desc'))

        if (searchQuery && typeof searchQuery === 'string' && searchQuery.trim()) {
            const searchTerm = searchQuery.toLowerCase().trim()
            const pageSize = pagination && pagination.limit ? pagination.limit : 20
            const rawPageLimit = pageSize * 2

            let startDoc = null
            if (pagination && pagination.startAfter) {
                startDoc = await getDoc(doc(db, 'series', pagination.startAfter))
            }

            let continueFetching = true
            let searchResults = []

            while (searchResults.length < pageSize && continueFetching) {
                let searchQ = q
                if (startDoc) {
                    searchQ = query(searchQ, startAfter(startDoc))
                }
                searchQ = query(searchQ, limit(rawPageLimit))

                const docs = await getDocs(searchQ)
                if (docs.docs.length === 0) {
                    continueFetching = false
                    break
                }

                for (const sermonDoc of docs.docs) {
                    const sermonData = sermonDoc.data()
                    const title = sermonData.title ? sermonData.title.toLowerCase() : ''
                    const description = sermonData.description ? sermonData.description.toLowerCase() : ''
                    const preacher = sermonData.preacher ? sermonData.preacher.toLowerCase() : ''

                    if (title.includes(searchTerm) || description.includes(searchTerm) || preacher.includes(searchTerm)) {
                        searchResults.push({ id: sermonData.docId, data: sermonData })
                        if (searchResults.length >= pageSize) break
                    }
                }

                if (docs.docs.length < rawPageLimit) {
                    continueFetching = false
                }
                startDoc = docs.docs[docs.docs.length - 1]
            }

            data = searchResults.slice(0, pageSize)
        } else {
            if (pagination) {
                if (pagination.startAfter) {
                    let startDoc = await getDoc(doc(db, 'series', pagination.startAfter))
                    q = query(q, startAfter(startDoc))
                }
                if (pagination.limit) {
                    q = query(q, limit(pagination.limit))
                }
            }

            let docs = await getDocs(q)

            docs.docs.forEach(doc => {
                data.push({ id: doc.data().docId, data: doc.data() })
            })
        }

        return data
    } catch (error) {
        return 'An error occurred: ' + error
    }
}

export default {
    getData,
    getSingleData,
    getSermonYears,
    getSermons,
    getRandomSermons
}